import React from 'react';
import { cn } from '../../utils/cn';

interface ContainerProps {
  children: React.ReactNode;
  className?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl' | 'full';
}

export const Container: React.FC<ContainerProps> = ({ 
  children, 
  className, 
  size = 'lg' 
}) => {
  const sizeClasses = {
    sm: 'max-w-2xl',
    md: 'max-w-4xl',
    lg: 'max-w-6xl',
    xl: 'max-w-7xl',
    full: 'max-w-full'
  };

  return (
    <div 
      className={cn(
        'mx-auto',
        // Responsive padding: 16px mobile, 24px tablet, 32px desktop
        'px-4 sm:px-6 lg:px-8',
        // Ensure minimum padding on very small screens
        'min-[320px]:px-4',
        sizeClasses[size],
        className
      )}
    >
      {children}
    </div>
  );
};